var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_15268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.9423 28H3.92283C1.87118 28 0.203613 26.356 0.203613 24.3333V7.66675C0.203613 5.64404 1.87118 4 3.92283 4H28.9423C30.9939 4 32.6615 5.64404 32.6615 7.66675V24.3333C32.6615 26.356 30.9939 28 28.9423 28ZM3.92283 6C2.99098 6 2.23223 6.74805 2.23223 7.66675V24.3333C2.23223 25.252 2.99098 26 3.92283 26H28.9423C29.8741 26 30.6329 25.252 30.6329 24.3333V7.66675C30.6329 6.74805 29.8741 6 28.9423 6H3.92283Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.96565 13.3333C5.4739 13.3333 4.26074 12.1375 4.26074 10.6667C4.26074 9.19604 5.4739 8 6.96565 8C8.45739 8 9.6703 9.19604 9.6703 10.6667C9.6703 12.1375 8.45739 13.3333 6.96565 13.3333ZM6.96565 10C6.59222 10 6.28936 10.2986 6.28936 10.6667C6.28936 11.0347 6.59222 11.3333 6.96565 11.3333C7.33883 11.3333 7.64169 11.0347 7.64169 10.6667C7.64169 10.2986 7.33883 10 6.96565 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21767 25.333C0.957906 25.333 0.698386 25.2358 0.500774 25.0398C0.10456 24.6492 0.10456 24.0159 0.500774 23.625L7.99318 16.2385C8.91834 15.3264 10.4235 15.3264 11.3471 16.2385L13.0514 17.9185L19.4888 11.5718C20.4138 10.6597 21.9191 10.6597 22.8428 11.5718L32.3638 20.9585C32.76 21.3491 32.76 21.9824 32.3638 22.373C31.9674 22.7637 31.325 22.7637 30.9288 22.373L21.4078 12.9863C21.2753 12.8557 21.0534 12.8557 20.9224 12.9863L13.768 20.0398C13.3718 20.4304 12.7294 20.4304 12.3332 20.0398L9.91235 17.6531C9.74049 17.4836 9.59859 17.4836 9.42674 17.6531L1.93457 25.0398C1.73696 25.2358 1.47744 25.333 1.21767 25.333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_15268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.4579,
    height: 32,
    fill: "white",
    transform: "translate(0.203613)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.aaecef3a97409702dd6dad41a0e5f440.svg";
export { ForwardRef as ReactComponent };